/**
 * FR01 20261001_LandingPage/001_Theming (FR-07, OR-02 A) - obsah stránky o cookies jako data bez
 * prezentace. Každá aplikace ho vykresluje vlastními styly (apps/web v Tailwindu s aplikačními
 * tokeny), proto balíček nezávisí na Tailwindu.
 *
 * Původně FR01 (20260920_CookieConsent): aplikace nepoužívá žádné non-essential (analytické ani
 * marketingové) cookies, stránka proto jen informuje, bez consent banneru.
 */
export interface CookieInfo {
  name: string;
  purpose: string;
  duration: string;
}

export const DECLARED_COOKIES: readonly CookieInfo[] = [
  {
    name: 'trenigo_session',
    purpose: 'Přihlášení a udržení relace uživatele akademie.',
    duration: 'Relace se odhlásí po 30 minutách nečinnosti, nejdéle však 12 hodin od přihlášení.',
  },
  {
    name: 'trenigo_csrf',
    purpose: 'Ochrana přihlášení proti CSRF útokům (tzv. double-submit token).',
    duration: 'Vázaná na dobu platnosti přihlašovací relace.',
  },
  {
    name: 'trenigo_admin_session',
    purpose: 'Přihlášení a udržení relace platformového administrátora.',
    duration: 'Relace se odhlásí po 15 minutách nečinnosti, nejdéle však 4 hodiny od přihlášení.',
  },
  {
    name: 'trenigo_admin_csrf',
    purpose: 'Ochrana přihlášení administrace platformy proti CSRF útokům (tzv. double-submit token).',
    duration: 'Vázaná na dobu platnosti přihlašovací relace.',
  },
];

/**
 * Kontaktní e-mail se ve zdroji ani v bundlu nikde neobjevuje jako čitelný souvislý text - části
 * adresy jsou zakódované přes Base64. Skrývá adresu jen před statickým čtením zdroje/bundlu, ne před
 * prohlížečem: výsledný `mailto:` odkaz v živém DOM dekódovanou adresu obsahovat musí.
 */
export const CONTACT_EMAIL_BASE64_PARTS = {
  user: 'b2JjaG9k',
  domain: 'dHJlbmlnbw==',
  tld: 'Y3o=',
} as const;

/**
 * Složí kontaktní e-mail synchronně (volá se přímo při renderu, ne až v useEffect), takže mezi
 * prvním vykreslením a finálním odkazem nic nebliká.
 */
export function decodeContactEmail(): string {
  const user = atob(CONTACT_EMAIL_BASE64_PARTS.user);
  const domain = atob(CONTACT_EMAIL_BASE64_PARTS.domain);
  const tld = atob(CONTACT_EMAIL_BASE64_PARTS.tld);
  return `${user}@${domain}.${tld}`;
}
